import { RouterProvider } from '@tanstack/react-router'
import { router } from './providers/router-provider'

export function App() {
  return <RouterProvider router={router} />
}

export default App
